import { connect } from 'react-redux';
import PurchaseYearView from './PurchaseYearView';
import { currentClientId } from '../../../AdvWorkflow/AdvWorkflowSelector';
import { updateSupportData } from '../../../AdvWorkflow/AdvWorkflowActions';
import { purchaseYearSelector, purchaseYearOptionsSelector } from './PurchaseYearSelector';
import { largePurchaseWorkflowCombinedData } from '../../LargePurchaseWorkflowSelector';
import onPostSave, { onPostProcess } from './PurchaseYearActions';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  purchaseYear: purchaseYearSelector(state, ownProps),
  purchaseYearOptions: purchaseYearOptionsSelector(state, ownProps),
  goal: largePurchaseWorkflowCombinedData(state, ownProps).LargePurchaseGoal,
  isNew: !(largePurchaseWorkflowCombinedData(state, ownProps).LargePurchaseGoal || {}).Id,
});

const mapDispatchToProps = dispatch => ({
  store: workflowId => (data, clientId) => dispatch(updateSupportData(data, workflowId, clientId)),
  onPostProcess,
  onPostSave: (isNew, workflowId, clientId) => (data) => {
    dispatch(onPostSave(isNew, workflowId, clientId, data));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PurchaseYearView);
